enum FileStatus {
  AwaitingApproval = "Awaiting Approval",
  Approved = "Approved",
  Declined = "Declined",
  Converted = "Converted",
  Error = "Error",
}

export default FileStatus;
